import React, { useEffect, useState } from 'react';
import { Tabs, Button, Divider } from 'antd';
import Icon from '@mdi/react';
import { mdiFilter, mdiPaletteSwatch, mdiPlus } from '@mdi/js';
import Design from 'modules/DashboardModule/widgets/WidgetConfigurationModal/components/Design';
import { useWidget } from 'components/Widget/useWidget';
import WidgetFilter from '../WidgetFilter';
import { useDashboardLayout } from 'store/redux/states/dashboard/dashboard.hooks';
import { widgetComponents } from 'modules/DashboardModule/widgets/widgetsConfig';
import useQueryParams from 'hooks/useQueryParams';
import { snackbar } from 'components/notifications/notifications';
import EditWidgetTitle from './EditWidgetTitle';
import WidgetEmptyState from './WidgetEmptyState';

const Configuration = (props) => {
  const { removeParams } = useQueryParams();
  const { config, updateWidget } = useDashboardLayout();
  const {
    chartConfig,
    connectToGetDataButton,
    filters,
    index,
    disableDateFilter,
    showCustomDesign,
    editableStr,
  } = useWidget();
  const [activetab, setActivetab] = useState(showCustomDesign ? 'design' : 'filters');

  useEffect(() => {
    setActivetab(showCustomDesign ? 'design' : 'filters');
  }, [showCustomDesign]);

  const items = [
    ...(showCustomDesign
      ? [
          {
            key: 'design',
            label: 'Design',
            icon: <Icon path={mdiPaletteSwatch} size={1} />,
            children: <Design value={props.value} />,
          },
        ]
      : []),
    {
      key: 'filters',
      label: 'Filters',
      icon: <Icon path={mdiFilter} />,
      children: <WidgetFilter />,
    },
  ];

  const createWidget = () => {
    const filteredFilters =
      disableDateFilter || !filters?.selected_period
        ? Object.fromEntries(
            Object.entries(filters).filter(
              ([key]) => !['date_from', 'date_to', 'date_range_key'].includes(key)
            )
          )
        : filters;

    const newConfig = {
      key: index,
      title: editableStr,
      position: widgetComponents[index]?.position || { x: 0, y: 0, w: 4, h: 4 },
      defaultFilter: filteredFilters,
      show: true,
      config: chartConfig,
    };

    snackbar.success(`${editableStr} Widget added successfully`);
    updateWidget([newConfig, ...config]);
    removeParams(['add_widget']);
  };

  const handleTypeChange = (key) => {
    setActivetab(key);
  };

  return (
    <div className='md:flex h-full justify-between gap-4 overflow-hidden md:max-h-[80vh] h-full'>
      <div className='relative w-full flex items-center justify-center overflow-y-auto overflow-x-hidden'>
        {connectToGetDataButton ? (
          <WidgetEmptyState>{props.children}</WidgetEmptyState>
        ) : (
          props.children
        )}
      </div>
      <div className='flex flex-col justify-between gap-2 w-full md:w-1/2 md:mt-0 mt-4'>
        <div className='flex-1 min-h-0 overflow-y-auto'>
          <EditWidgetTitle />

          <Tabs
            className='flex w-full'
            activeKey={activetab}
            items={items}
            onChange={handleTypeChange}
          />
        </div>
        <div>
          <Divider />
          <Button
            icon={<Icon path={mdiPlus} />}
            type='primary'
            className='ml-auto'
            onClick={createWidget}
          >
            Add
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Configuration;
